import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import FormTemplate, { THEMES } from '@/components/formTemplate/index';
import { SHIPPING_ADDRESS } from '@/constants/shippingAddress';

function ShippingAddressView({
  edit = null,
  step = null,
  withHorizontalSeparator = false,
  addressInfo = null,
  deliveryText = null,
}) {
  return (
    <FormTemplate
      titleText={SHIPPING_ADDRESS.TITLE}
      step={step}
      theme={THEMES.LONG}
      action={
        edit
          ? {
              onClick: edit,
              label: 'Editar',
            }
          : null
      }
      withHorizontalSeparator={withHorizontalSeparator}
    >
      <div className="personal-data-view-container">
        {addressInfo && (
          <div>
            <Text
              text={addressInfo}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </div>
        )}
        {deliveryText && (
          <div>
            <Text
              text={deliveryText}
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </div>
        )}
      </div>
      <style jsx>
        {`
          :global(.checkbox-container) {
            margin-top: 8px;
          }
          :global(.address-container-wrapper) {
            padding-top: 12px;
          }
          .personal-data-view-container > * {
            margin-bottom: 8px;
          }
          .personal-data-view-container > *:last-child {
            margin-bottom: 0px;
          }
        `}
      </style>
    </FormTemplate>
  );
}

export default ShippingAddressView;
